import { Routes } from '@angular/router';
import { AppRoutes } from './core/constants/app-routes';
import { PublicLayout } from './core/layout/public-layout/public-layout';

export const routes: Routes = [
  {
    path: AppRoutes.PORTAL_WIDGET,
    loadComponent: () =>
      import('./features/portal-widget/portal-widget-embed').then((m) => m.PortalWidgetEmbed),
  },
  {
    path: AppRoutes.HOME,
    component: PublicLayout,
    children: [
      { path: 'vip/:companyId', loadComponent: () => import('./features/vip-club/vip-club').then(m => m.VipClub) },
      {
        path: AppRoutes.HOME,
        loadComponent: () => import('./features/homepage/homepage').then((m) => m.Homepage),
      },
      {
        path: AppRoutes.JOIN_PLATFORM,
        loadComponent: () =>
          import('./features/join-platform/join-platform').then((m) => m.JoinPlatform),
      },
      {
        path: AppRoutes.PORTAL_WIDGET_PREVIEW,
        loadComponent: () =>
          import('./features/portal-widget/portal-widget-preview').then(
            (m) => m.PortalWidgetPreview,
          ),
      },
      {
        path: AppRoutes.PRIVACY_POLICY,
        loadComponent: () =>
          import('./features/legal/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
      },
      {
        path: AppRoutes.TERMS_AND_CONDITIONS,
        loadComponent: () =>
          import('./features/legal/terms-and-conditions/terms-and-conditions').then(
            (m) => m.TermsAndConditions,
          ),
      },
      {
        path: AppRoutes.RESTAURANTS.ROOT,
        children: [
          {
            path: '',
            loadComponent: () => import('./features/restaurants/list/list').then((m) => m.List),
          },
          {
            path: `:${AppRoutes.RESTAURANTS.RESTAURANT_ID}`,
            loadComponent: () =>
              import('./features/restaurants/details/details').then((m) => m.Details),
          },
          {
            path: `:${AppRoutes.RESTAURANTS.RESTAURANT_ID}/${AppRoutes.RESTAURANTS.RESERVATION}`,
            loadComponent: () =>
              import('./features/reservations/reservation/reservation').then((m) => m.Reservation),
          },
        ],
      },
    ],
  },
];
